import {
  Size2Dum5ayuyhhau7 as Size2D,
  Colors_getInstance1qvds1isfbag2 as Colors_getInstance,
  get_degrees3czcd4ojw4i as get_degrees,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  readBitmap1dn2o52mvbpv4 as readBitmap,
  Companion_getInstance21plr7f541fx9 as Companion_getInstance,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Angle2itorpob18n08 as Angle,
  Companion_getInstancech3bi94cc2ym as Companion_getInstance_0,
  get_EASE_IN_OUT1plt1ext4tf71 as get_EASE_IN_OUT,
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  Companion_getInstancew949xxob44bw as Companion_getInstance_1,
  Resources1ysf2j4wd5yk7 as Resources,
  Level_INFO_getInstance2ziz2o3m3loni as Level_INFO_getInstance,
} from './korlibs-all.mjs';
import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  numberToDouble210hrknaofnhf as numberToDouble,
  Unit_instance104q5opgivhr8 as Unit_instance,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getKClass1s3j9wy1cofik as getKClass,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KClass1cc9rfeybg8hs as KClass,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Korge11eut3mr7473l as Korge,
  Image1b2d7ghyim7p5 as Image,
  addTo25e29vq105prw as addTo,
  anchor3c5itxst996yy as anchor,
  scalea9fc0mbrr7ub as scale,
  xy1gb51vhy014mx as xy,
  tween3jbh5j0ixzsj7 as tween,
  Scenezu810y12qpqp as Scene,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views17oaxjs1xed1j as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  SceneContainer99ijjqni12hp as SceneContainer,
  Companion_getInstancezug9z9lglek as Companion_getInstance_2,
  Stage1ggtrzujnnkl0 as Stage,
} from './korge-root-korge.mjs';
import {
  V22su20mpwty0v0 as V2,
  _interpolateAngle308nqn33qn9pa as _interpolateAngle,
} from './korge-root-korge-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class MyScene extends Scene {
  m7b(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl(_this__u8e3s4, this, $completion), $completion);
  }
}
class main$slambda {
  t6t($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, $this$Korge, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.t6t(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
//endregion
function main($completion) {
  var tmp = Size2D.e37(512, 512);
  var tmp_0 = Colors_getInstance().g29('#2b2b2b');
  return Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
}
function *_generator_sceneMain__5xvlzl(_this__u8e3s4, $this, $completion) {
  var minDegrees = get_degrees(-16);
  var maxDegrees = get_degrees(16);
  // Inline function 'korlibs.korge.view.image' call
  var tmp = readBitmap(get_resourcesVfs().l1i('korge.png'), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var texture = tmp;
  var anchor_0 = Companion_getInstance().n35_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Image.k83(texture, anchor_0);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'MyScene.sceneMain.<anonymous>' call
  this_1.f86(maxDegrees);
  // Inline function 'korlibs.korge.view.anchor' call
  anchor(this_1, Anchor2D.a36(numberToDouble(0.5), numberToDouble(0.5)));
  scale(this_1, 0.8);
  // Inline function 'korlibs.korge.view.position' call
  xy(this_1, numberToDouble(256), numberToDouble(256));
  var image = this_1;
  while (true) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_2 = rotation$factory(image);
    var tmp_0 = this_2.get();
    var tmp_1 = [new V2(this_2, tmp_0, new Angle(minDegrees), _interpolateAngle$ref(), false)];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$7 = toDuration(1, DurationUnit_SECONDS_getInstance());
    var tmp_2 = tween(image, tmp_1, tmp$ret$7, get_EASE_IN_OUT(Companion_getInstance_0()), VOID, VOID, VOID, VOID, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    // Inline function 'korlibs.korge.tween.get' call
    var this_3 = rotation$factory_0(image);
    var tmp_3 = this_3.get();
    var tmp_4 = [new V2(this_3, tmp_3, new Angle(maxDegrees), _interpolateAngle$ref_0(), false)];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$10 = toDuration(1, DurationUnit_SECONDS_getInstance());
    var tmp_5 = tween(image, tmp_4, tmp$ret$10, get_EASE_IN_OUT(Companion_getInstance_0()), VOID, VOID, VOID, VOID, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
  }
  return Unit_instance;
}
function _interpolateAngle$ref() {
  var l = function (p0, p1, p2) {
    return new Angle(_interpolateAngle(p0.g35_1, p1.b36_1, p2.b36_1));
  };
  l.callableName = '_interpolateAngle';
  return l;
}
function _interpolateAngle$ref_0() {
  var l = function (p0, p1, p2) {
    return new Angle(_interpolateAngle(p0.g35_1, p1.b36_1, p2.b36_1));
  };
  l.callableName = '_interpolateAngle';
  return l;
}
function *_generator_invoke__zhh2q8($this, $this$Korge, $completion) {
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_0()));
  var name = 'sceneContainer';
  var size = Companion_getInstance_1().e3d_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp = views($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var views_0 = tmp;
  var width = size.jk();
  var height = size.kk();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_0 = findFirstAscendant($this$Korge, main$slambda$lambda);
    var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
    var tmp0_elvis_lhs = base == null ? null : base.h1j();
    rwidth = tmp0_elvis_lhs == null ? views_0.k6y_1.h1j() : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = base == null ? null : base.i1j();
    rheight = tmp1_elvis_lhs == null ? views_0.k6y_1.i1j() : tmp1_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.l74(views_0, defaultTransition, name, Size2D.s3b(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var sceneContainer = addTo(this_0, $this$Korge);
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = sceneContainer.g74_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(MyScene);
  var injects_0 = injects.slice();
  var sceneInjector = sceneContainer.f74_1.a6x_1.y2l().w2l(getKClass(SceneContainer), sceneContainer).w2l(getKClass(Resources), new Resources(sceneContainer.qo(), sceneContainer.f74_1.h75().w2z_1, sceneContainer.f74_1.h75()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_1 = getKClassFromExpression(inject);
    sceneInjector.w2l(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
  }
  // Inline function 'main.<anonymous>.<anonymous>' call
  var newScene = new MyScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_2().m7c_1;
  var level = Level_INFO_getInstance();
  var tmp_2;
  if (this_1.k1a(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$8 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.j1a(level, tmp$ret$8);
    tmp_2 = Unit_instance;
  }
  if (true) {
    newScene.h2m(sceneInjector);
    var tmp_3 = getKClassFromExpression(newScene);
    var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
    sceneContainer.f74_1.a6x_1.a2m(tmp_4, main$slambda$lambda_0(sceneInjector));
  }
  var tmp_5 = sceneContainer.o7c(newScene, time, transition, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
function main$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function main$slambda$lambda_0($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'main.<anonymous>.<anonymous>' call
    return new MyScene();
  };
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.t6t($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function rotation$factory($b0) {
  return getPropertyCallableRef('rotation', 0, KMutableProperty0, function () {
    return new Angle($b0.s7m());
  }, function (value) {
    return $b0.f86(value.b36_1);
  });
}
function rotation$factory_0($b0) {
  return getPropertyCallableRef('rotation', 0, KMutableProperty0, function () {
    return new Angle($b0.s7m());
  }, function (value) {
    return $b0.f86(value.b36_1);
  });
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
//region block: post-declaration
initMetadataForClass(MyScene, 'MyScene', MyScene, VOID, VOID, [0]);
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
//endregion
mainWrapper();
